import { message } from "antd";
import dayjs from "dayjs";
import { LoadingLogTable } from "features/loading-log/component/table/loading-Item";
import { LoadingLogViewTopBar } from "features/loading-log/component/Top-bar/LoadingView-top-bar";
import { LoadingFilterFormValues, LoadingFilterFormValuesPaginated } from "features/loading-log/component/Top-bar/type";
import { useGetLoadingList } from "features/loading-log/use-cases/get-getLoading";
import { useApproveReject } from "features/log/use-cases/create-weighbride";
import { MatrialFilterFormValuesPaginated } from "features/master/components/master-filter-form";
import { usePaginationParams } from "hooks";
import { omit } from "lodash";
import {  useState } from "react";
import { formatDate } from "utils/date";
export const LoadingLog = () => {
  const getInitialFilterValues: LoadingFilterFormValues = {
    MaterialName: undefined,
    DriverName:undefined,
    VehicleNumber:undefined,
    date: null,  
    WeightType:undefined
  };
  const [userEditData, setUserEditData] = useState<any>(undefined);
  const [showAppUserModal, setShowAppUserModal] = useState(false);
  const { params, updateParams, resetPage } =
    usePaginationParams<LoadingFilterFormValuesPaginated>({
      page: 1,
      size: 10,
      ...getInitialFilterValues,
    });
  const preparePayload = (params1: MatrialFilterFormValuesPaginated) => {
    const createdAtFrom = params1.date?.[0];
    const createdAtTo = params1.date?.[1];

    return {
      ...omit(params1, ['date']),
      LoadingStartDate: createdAtFrom
        ? formatDate({
          date: dayjs(createdAtFrom).startOf('day'),
          format: 'dbDate',
        })
        : undefined,
      LoadingEndDate: createdAtTo
        ? formatDate({
          date: dayjs(createdAtTo).endOf('day'),
          format: 'dbDate',
        })
        : undefined,
    };
  };
  const { mutate } = useApproveReject();

  const onApproveReject = (log: any, isApproved: number) => {
    const payload = {
      EntryId: log?.entryId,
      Type: log?.entryType,
      IsApproved: isApproved==1?1:2 ,
    };

    mutate(payload, {
      onError: () => {
        message.error("Something went wrong, please try again.");
      },
    
    });
  };
  const getLoadingListQueryResponse: any = useGetLoadingList(preparePayload(params as any), {
    retry: false,
  });

  const handleFiltersChange = (values: LoadingFilterFormValuesPaginated) => {
    updateParams(values);
    resetPage();
  };
  
  return (
    <>
      <LoadingLogViewTopBar
        getInitialFilterValues={getInitialFilterValues as any}
        handleFilter={handleFiltersChange}
        userEditData={userEditData}
        showAppUserModal={showAppUserModal}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getLoadingListQueryResponse.refetch}
      />
      <LoadingLogTable
        isListLoading={
          getLoadingListQueryResponse.isFetching
        }
        vehicleList={getLoadingListQueryResponse?.data?.res?.items}
        itemsCount={getLoadingListQueryResponse?.data?.totalRecords || 0}
        tableParams={params as any}
        updateParams={updateParams}
        setUserEditData={setUserEditData}
        setShowAppUserModal={setShowAppUserModal}
        onApproveReject={onApproveReject}
        onRefresh={getLoadingListQueryResponse.refetch}
        isFetching={ getLoadingListQueryResponse.isFetching}

      />
    </>


  );
};
